import React, { createContext, useContext, useEffect, useState } from "react";

function getTenantFromSubdomain() {
  const { hostname } = window.location;

  let [tenant, domain] = hostname.split(".");

  if (!domain && tenant === process.env.REACT_APP_DOMAIN.split(".")[0])
    return '-1';

  if (tenant === "www") return "";

  return tenant;
}

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(getTenantFromSubdomain());
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    if (window) {
      setTenant(getTenantFromSubdomain());
      setIsLoading(false);
    }
  }, [window.location.hostname, refresh]);

  const refreshTenant = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <TenantContext.Provider value={{ tenant, isLoading, refreshTenant }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error("useTenant must be used within a TenantProvider");
  }
  return context;
};
